<form [formGroup]="berekeningBox1FormGroup">
  <div formGroupName="box1">
    <div formGroupName="opbouwInkomen">
      <div
        *ngIf="berekeningBox1.box1?.opbouwInkomen?.uitgavenVoorInkomensvoorzieningen !== undefined">
        <div class="row">
          <div class="col col-1">
            <p>Af: Premies inkomensvoorzieningen</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control
              formControlName="uitgavenVoorInkomensvoorzieningen"
              id="uitgavenVoorInkomensvoorzieningen"
              class="custom-input-150"
              [decimals]="0"
              align="right"
              prefix="€ -"
            ></snelstart-ui-number-form-control>
          </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
        </div>
      </div>
    </div>
  </div>
</form>

